var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { ref: "trainingSwiper", staticClass: "swiper" }, [
    _c("div", { staticClass: "swiper__title" }, [
      _vm._v(_vm._s(_vm.slides[_vm.activeIndex].title))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "swiper-wrapper" },
      _vm._l(_vm.slides, function(slide, i) {
        return _c(
          "div",
          { key: "Swiper-Slide_" + i, staticClass: "swiper-slide" },
          [
            _c(
              "div",
              {
                staticClass: "swiper-slide__card",
                class: _vm.activeIndex === i && "active"
              },
              [
                _c("div", { staticClass: "image" }, [
                  _c("img", {
                    attrs: { src: "" + _vm.mediaBaseUrl + slide.image }
                  })
                ])
              ]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "swiper-elements" }, [
      _c(
        "div",
        { staticClass: "swiper-pagination" },
        _vm._l(_vm.slides, function(_, i) {
          return _c("button", {
            key: "Swiper-Pagination-bullet_" + i,
            staticClass: "swiper-pagination__bullet",
            class: _vm.activeIndex === i && "active",
            on: {
              click: function() {
                return _vm.slideToLoop(i)
              }
            }
          })
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-button-prev", on: { click: _vm.prev } }),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-button-next", on: { click: _vm.next } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }